import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const LocationSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setLocation = (e, { value }) => {
        dispatch(filterActionCreators.setGameLocation(value));
    };

    const selectedLocation = useSelector((state) => state.playersAndTeams.filter.values.homeRoad);

    const options = [
        {
            value: '',
            label: `${intl.formatMessage(commonMessages.labels.home)} + ${intl.formatMessage(commonMessages.labels.road)}`,
            key: 'both',
        },
        { value: 'H', label: intl.formatMessage(commonMessages.labels.home), key: 'h' },
        { value: 'R', label: intl.formatMessage(commonMessages.labels.road), key: 'r' },
    ];
    const value = options.find((obj) => obj.value === selectedLocation);

    return (
        <Select
            onOptionChange={setLocation}
            options={options}
            selectedOption={value}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(LocationSelect);
